module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 853
// module chunks = 0